import React from 'react'
import Detail from './components/UserDetail'

const Route = () => ({
  index: true,
  path: ':userId',
  element: <Detail />,
})

export default Route
